import { signal } from '@angular/core';
import { UploadUrlResponse } from './file-upload.service';

/**
 * File selected by the user.
 */
export class SelectedFile {
  /**
   * Creates an instance of selected file.
   * @param file File system file.
   */
  constructor(public readonly file: File) { }

  // file upload service props

  /**
   * File upload URL.
   */
  public readonly uploadUrl = signal<UploadUrlResponse | null>(null);
  /**
   * File upload progress.
   */
  public readonly progress = signal<number>(0);
  /**
   * File upload result:
   * - null - not started/in progress
   * - false - error
   * - true - success
   */
  public readonly uploadResult = signal<boolean | null>(null);

  // portal props

  /**
   * Add file to upload result:
   * - null - not started/in progress
   * - false - error
   * - true - success
   */
  public readonly addFileResult = signal<boolean | null>(null);
}

/**
 * Validates file.
 *
 * @param file File to validate.
 * @param fileTypes A list of supported MIME types, or null or empty array if all files supported.
 * @returns True if file is valid, otherwise - false.
 */
export function isValidFile(file: File, fileTypes: string[]): boolean {
  return fileTypes?.length < 1 || fileTypes.includes(file.type);
}
